import axios, { AxiosRequestConfig } from 'axios';
import {
  NR01CreateStockGruppeRequest,
  NR01CreateStockGruppeResponse,
  NR01DeleteStockGruppeResponse,
  NR01StockGruppeResponse,
  NR01UpdateStockGruppeRequest,
  NR01UpdateStockGruppeResponse,
  NR01BulkImportStockGruppeRequest,
  NR01BulkImportStockGruppeResponse,
} from '../models/NR01StockGruppeOverview';
import CSharpUtils from './CSharpUtils';
import Utils from './Utils';

export const fetchNR01StockGruppeOverview = (
  companyId: number,
  page: number,
  pageSize: number,
  search?: string,
  sortBy?: string,
  sortDirection?: string,
) => {
  const config: AxiosRequestConfig = {
    method: 'get',
    url: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/stockgruppe/overview`,
    params: {
      CompanyId: companyId,
      Page: page,
      PageSize: pageSize,
      ...(search ? { Search: search } : {}),
      ...(sortBy ? { SortBy: sortBy } : {}),
      ...(sortDirection ? { SortDirection: sortDirection } : {}),
    },
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    responseType: 'json',
    timeout: 30000,
  };

  return axios.request<NR01StockGruppeResponse>(config);
};

export const createNR01StockGruppe = (
  companyId: number,
  payload: NR01CreateStockGruppeRequest,
) => {
  const config: AxiosRequestConfig = {
    method: 'post',
    url: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/stockgruppe/create`,
    data: {
      companyId: companyId.toString(),
      groupNumber: payload.groupNumber,
      groupName: payload.groupName,
      statisticsGroup: payload.statisticsGroup,
      account: payload.account,
      costCenter: payload.costCenter,
      soldGoodsCostPrice: payload.soldGoodsCostPrice,
      soldGoodsSalesPrice: payload.soldGoodsSalesPrice,
      profitPercentage: payload.profitPercentage,
    },
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    responseType: 'json',
    timeout: 30000,
  };

  return axios.request<NR01CreateStockGruppeResponse>(config);
};

export const deleteNR01StockGruppe = (
  companyId: number,
  groupNumber: string,
) => {
  const config: AxiosRequestConfig = {
    method: 'delete',
    url: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/stockgruppe/delete/${companyId}/${encodeURIComponent(groupNumber)}`,
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    responseType: 'json',
    timeout: 30000,
  };

  return axios.request<NR01DeleteStockGruppeResponse>(config);
};

export const updateNR01StockGruppe = (
  companyId: number,
  groupNumber: string,
  payload: NR01UpdateStockGruppeRequest,
) => {
  const config: AxiosRequestConfig = {
    method: 'put',
    url: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/stockgruppe/update/${companyId}/${encodeURIComponent(groupNumber)}`,
    data: {
      companyId: companyId.toString(),
      groupNumber: payload.groupNumber,
      groupName: payload.groupName,
      statisticsGroup: payload.statisticsGroup,
      account: payload.account,
      costCenter: payload.costCenter,
      soldGoodsCostPrice: payload.soldGoodsCostPrice,
      soldGoodsSalesPrice: payload.soldGoodsSalesPrice,
      profitPercentage: payload.profitPercentage,
    },
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    responseType: 'json',
    timeout: 30000,
  };

  return axios.request<NR01UpdateStockGruppeResponse>(config);
};

export const bulkImportNR01StockGruppe = (
  companyId: number,
  items: NR01BulkImportStockGruppeRequest['items'],
) => {
  const config: AxiosRequestConfig = {
    method: 'post',
    url: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/stockgruppe/bulk-import`,
    data: {
      companyId: companyId.toString(),
      items: items,
    },
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    responseType: 'json',
    timeout: 60000, // Longer timeout for bulk operations
  };

  return axios.request<NR01BulkImportStockGruppeResponse>(config);
};
